module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"noOfferingsTitle":"Noch nichts im Shop","noOfferingsMessage":"Schau später noch einmal vorbei","allCategories":"Alle"},"en":{"noOfferingsTitle":"Nothing in the shop yet","noOfferingsMessage":"Check back later","allCategories":"All"}}')
  delete Component.options._Ctor
}
